
// const entry = () => import('@/components/entry');
// const agreement = () => import('@/views/register/agreement');
// const branch = () => import('@/views/register/branch');
// const write = () => import('@/views/register/write');
// const major = () => import('@/views/register/major');
// const infoBk = () => import('@/views/register/infoBk');
// const notice = () => import('@/views/notice/index');

const routes = [
	// {
	//     path: '/',
	//     name: "entry",
	//     component: entry,
	//     meta: {
	//         title: '报名入口'
	//     }
	// },
    // {
    //     path: '/register/agreement',
    //     name: "register",
    //     component: agreement,
    //     meta: {
    //         title: '阅读报名须知'
    //     }
    // },
	// {
	//     path: '/register/branch',
	//     name: "branch",
	//     component: branch,
	//     meta: {
	//         title: '选择教学点'
	//     }
	// },
	// {
	//     path: '/register/write',
	//     name: "write",
	//     component: write,
	//     meta: {
	//         title: '注册学员资料'
	//     }
	// },
	// {
	//     path: '/register/major',
	//     name: "major",
	//     component: major,
	//     meta: {
	//         title: '选择报名专业'
	//     }
	// },
	// {
	//     path: '/register/infoBk',
	//     name: "infoBk",
	//     component: infoBk,
	//     meta: {
	//         title: '报考信息'
	//     }
	// },
	// {
	//     path: '/notice',
	//     name: "notice",
	//     component: notice,
	//     meta: {
	//         title: '入学通知书'
	//     }
	// },
]
export default routes;